import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const TestimonialsIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 42 47"
      {...props}
    >
      <g>
        <path d="M13,34.9c-3.4,0-10,1.8-10,6V47h2v-6.1c0-2.3,4.8-4,8-4s8,1.7,8,4V47h2v-6.1C23,36.7,16.4,34.9,13,34.9z" />
        <path d="M7,27v1c0,3.3,2.7,6,6,6s6-2.7,6-6v-1c0-3.3-2.7-6-6-6S7,23.7,7,27z M9,27c0-2.2,1.8-4,4-4s4,1.8,4,4v1
                c0,2.2-1.8,4-4,4s-4-1.8-4-4V27z"/>
        <path d="M38,0H4C1.8,0,0,1.8,0,4v19c0,2.2,1.8,4,4,4h2v-2H4c-1.1,0-2-0.9-2-2V4c0-1.1,0.9-2,2-2h34c1.1,0,2,0.9,2,2v19
                c0,1.1-0.9,2-2,2h-6.7L24,32.9V25h-4v2h2v6c0,0.8,0.4,1.4,1.1,1.8c0.3,0.1,0.6,0.2,0.9,0.2c0.5,0,0.9-0.2,1.3-0.5l6.9-7.5H38
                c2.2,0,4-1.8,4-4V4C42,1.8,40.2,0,38,0z"/>
        <rect x="10" y="8" width="21" height="2" />
        <rect x="10" y="12" width="21" height="2" />
        <rect x="10" y="16" width="14" height="2" />
      </g>
    </StyledSVGIcon>
  );
};